<template>
  <v-card @click.stop="changeClicked" class="session-card" :style="clicked ? 'display:block;' : ''" flat @click="showOrders = !showOrders" :disabled="disabled" :ripple="false">
    <!-- {{session}} -->
    <v-icon v-if="sessionCompleted" small :color="'black'" style="margin-right: 1rem;">
      {{appropriateIcon}}
    </v-icon>
    <v-icon v-else-if="!clicked && !sessionCompleted" @click.stop="endSession(session)" small :color="'red'" style="margin-right: 1rem;">
      fa-solid fa-trash
    </v-icon>
    <div :class="{'opened': !sessionCompleted, 'completed': sessionCompleted}" style="padding: .5rem; flex: 1 1 90%;">
      <v-row>
        <v-col cols="12" class="d-flex justify-space-between align-center">
          <!-- {{session.id}} -->
          <div style="display:flex; flex-direction:column;">
            <span class="session-card__title" :inner-html.prop="sessionLocation"></span>
            <span>{{startMoniker}}: {{startDate}}</span> <!--<span style="font-size: 20px;">-->
            <span>{{endUser ? `${endUser}: ${endDate}` : 'V teku..'}}</span>
          </div>
          <div style="display:flex; flex-direction:column;">
            <span class="session-card__title" :inner-html.prop="numberOfOrders"></span>
            <span class="session-card__title" :inner-html.prop="ordersNumbers"></span>
            <span v-if="sessionCompleted" class="session-card__title" :inner-html.prop="`Zaključil: ${endUser}`"></span>
          </div>
          <span class="float-right session-card__total" :inner-html.prop="ordersTotalAmount | price(2)"></span>
        </v-col>
      </v-row>
    </div>
    <v-icon @click.stop="resurrectSession" id="refreshIcon" v-if="!clicked && sessionCompleted && myCompany && (myCompany.company_type === 2 || childCompanyUserIsTaken)" small :color="'black'" style="flex: 1rem;">
      fa-refresh
    </v-icon>
    <!-- <h3 class="sessionNotification" v-if="showOrders">NAROČILA SEJE:</h3> -->
    <v-row v-if="showOrders" class="justify-end">
      <v-col cols="11" v-for="order in filteredOrders" :key="order.id">
        <OrderCard
          :order="order"
        />
      </v-col>
    </v-row>
    <!-- <v-icon v-if="!clicked && !sessionCompleted" @click.stop="endSession(session)" small :color="'white'" class="iconActionDelete">
      fa-solid fa-trash
    </v-icon> -->
    <ConfirmDialog
      ref="confirmdialogunsaved"
      title="Opozorilo"
      okBtnText="Razumem"
      :normal="false"
      v-model="showWarningModal"
    />
  </v-card>
</template>

<script>
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
import ButtonActionInfo from './ButtonActionInfo'
import Vue from 'vue'
import OrderCard from './orderCard.vue'
import ConfirmDialog from './ConfirmDialog'
export default {
  components: {
    ButtonActionInfo,
    ConfirmDialog,
    OrderCard
  },
  props: {
    lON: {
      required: false,
      type: Boolean
    },
    session: {
      required: true,
      type: Object
    },
    orders: {
      required: true,
      type: Object
    },
    disabled: {
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      showOrders: false,
      clicked: false,
      showWarningModal: false,
    }
  },
  computed: {
    ...mapGetters('auth', ['childCompanyUserIsTaken']),
    myCompany () {
      return this.$store.state.companies.myCompany
    },
    endUser () {
      return this.session.moniker_end
    },
    appropriateIcon () {
      if (this.session.reason === 1) return 'fa-solid fa-file-invoice-dollar'
      if (this.session.reason === 2) return 'fa-solid fa-eraser'
      if (this.session.reason === 3) return 'fa-exchange-alt'
    },
    sessionLocation () {
      // return `${this.session.table_name || this.session.session_name.replace('TMPZT-','')} - ${this.session.electronic_device_name} - <span style="font-weight: bold; font-size: 25px;">${Vue.filter('sloDateTime')(this.session.start_date)}-${this.endUser || 'V teku'}</span>`
      // return `<b>${this.session.table_name || this.session.session_name.replace('TMPZT-','')} - ${this.session.electronic_device_name}</b>`
      return `<b>${this.session.table_name || this.session.session_name.replace('TMPZT-','')}</b>`
    },
    startMoniker () {
      return this.filteredOrders[this.filteredOrders.length - 1] && this.filteredOrders[this.filteredOrders.length - 1].moniker || '?'
    },
    startDate () {
      return `${Vue.filter('sloDateTime')(this.session.start_date)}`
    },
    endDate () {
      return `${this.session.end_date ? Vue.filter('sloDateTime')(this.session.end_date) : 'V teku..'}`
    },
    sessionCompleted () {
      return this.session.end_date !== null
    },
    ordersTotalAmount () {
      if (!this.orders) return
      // console.log(this.orders)
      var articlesAmount = 0.0
      return this.orders.reduce((total, session) => {
        total = total + parseFloat(session.payment_amount)
        if (session.articles.length > 0) {
          articlesAmount = session.articles.reduce((totalArticles, article) => {
            totalArticles += article.addons.reduce((totalAddons, addon) => totalAddons + parseFloat(addon.amount), 0)
            // console.log(totalArticles)
            return totalArticles
          }, 0.0)
        }
        total += articlesAmount
        return total
      }, 0)
    },
    numberOfOrders () {
      if (!this.orders) return
      return `Št. naročil: <span style="font-weight: bold; font-size: 25px;">${this.orders.length}</span>`
    },
    ordersNumbers () {
      if (!this.orders) return
      if (this.orders.length <= 5) {
        return `<span style="font-size: 20px;">${this.orders.map(order => {
          if (order.number <= 9999) {
            const a = String(order.number)
            order.number = (a.padStart(4, '0'))
          } else {
            const a = (order.number).toString()
            const b = a.slice(-4)
            order.number = b
          }
          return order.number
          // return ' BL'+order.electronic_device_name+'-'+order.number
        }).sort((a, b) => a - b)}</span>`
      } else {
        return `<span style="font-size: 20px;">${this.orders.slice(0, 5).map(order => {
          if (order.number <= 9999) {
            const a = String(order.number)
            order.number = (a.padStart(4, '0'))
          } else {
            const a = (order.number).toString()
            const b = a.slice(-4)
            order.number = b
          }
          return order.number
          // return 'BL-' + order.number
        }).sort((a, b) => a - b)}...</span>`
      }
    },
    filteredOrders () {
      if (this.lON) {
        if (!this.orders) {
          return []
        }
        return this.orders.filter(o => ({
          ...o,
          articles: o.articles.filter(art => art.quantity < 0)
        }))
        // return this.orders
      } else {
        return this.orders
      }
    }
  },
  methods: {
    ...mapActions('orders', ['createOrder']),
    ...mapActions('sessions', ['endTableSession']),
    async resurrectSession () {
      // console.log('session ressurect', this.session, this.session.id, this.filteredOrders)
      // const name = this.session.session_name ? `${this.session.session_name}SID${this.session.id}` : `${this.session.table_name}SID${this.session.id}`
      this.showWarningModal = true
      const text = `Ali ste prepričani, da želite povrniti <span style="font-weight: bolder;">${this.session.table_name || this.session.session_name}</span> ?`
      const confirmationDialog = await this.$refs.confirmdialogunsaved.pop(text)
      if (confirmationDialog) {
        this.showWarningModal = false
        const resurrectedSessionNewDate = moment().format('DD.MM.YYYY HH:mm:ss')
        const name = this.session.session_name ? `TMPZT-${this.session.session_name} (${resurrectedSessionNewDate})` : `TMPZT-${this.session.table_name} (${resurrectedSessionNewDate})`
        if (this.filteredOrders.length) {
          const allOrders = []
          for (var orderIndex in this.filteredOrders) {
            // console.log('ord: ', this.filteredOrders[orderIndex])
            const oldOrder = this.filteredOrders[orderIndex]
            const modifiedOrder = {
              articles: oldOrder.articles.map(orderArticle => {
                return {
                  ...orderArticle,
                  reason: null,
                  reason_name: null,
                }
              }),
              issuer: oldOrder.issuer,
              comment: oldOrder.comment,
              reason: null,
              reason_name: null,
              name: name
            }
          allOrders.push(this.createOrder(modifiedOrder))
          }
          await Promise.all(allOrders)
        }
        setTimeout(() => {
          this.$emit('refreshSessions')
        }, 500)
      }
    },
    changeClicked () {
      this.clicked = !this.clicked
    },
    async endSession (session) {
      const end_date = moment().format('YYYY-MM-DDTHH:mm:ss')
      const tableSessionId = this.session.id
      this.showWarningModal = true
      const text = `Ali ste prepričani, da želite zaključiti <span style="font-weight: bolder;">${session.table_name || session.session_name}</span> ?`
      const confiramtion = await this.$refs.confirmdialogunsaved.pop(text)
      const electronic_device = session.electronic_device
      if (confiramtion) {
        this.endTableSession({ end_date, tableSessionId, electronic_device })
        this.showWarningModal = false
        setTimeout(() => {
          this.$emit('refreshSessions')
        }, 500)
      }
    }
  }
}
</script>

<style lang="scss">

#refreshIcon:hover {
  color: #39bb39 !important;
}

.iconActionDelete {
  margin: auto 0px;
  padding: 11px;
  font-size: 16px;
  flex: 1;
  color: #fff !important;
  background: red;
  height: fit-content;
  border-radius: 20px !important;
  margin-left: 1rem;
  &:hover {
    color: #000 !important;
    background: #fff !important;
  }
}

.listlist {
  display: flex;
  justify-content: space-between;
}

.session-card.v-card--disabled > *:not(.v-card__progress) {
  opacity: 1;
}
</style>

<style lang="scss" scoped>

.sessionNotification {
  text-align: center;
  margin: 1rem 0;
}

.list{
  position: relative;
  width: 100%;
  margin: 1rem 0;
  padding: 0;
  list-style-type: none;
  transform-origin: top;
  transition: transform .4s ease-in-out;
  overflow: hidden;
  li{
    padding: 10px;
    background: white;
    border-bottom: solid thin #eee;
    border-left: solid medium #cbc;
  }
}
.slide-enter, .slide-leave-to{
  transform: scaleY(0);
}

.opened {
  background-color: #95e895;
}

.completed {
  background-color: #c64242;
}

.session-card {
  // padding-right: 0 !important;
  padding: 0 15px;
  font-size: 20px;
  border: 2px solid #EDEDED;
  transition:all 5s ease-in-out;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px !important;
  display: flex;

  .completed {
    .session-card__details {
      color: #000;
    }
  }

  &__title {
    &.completed {
      color: #c64242;
    }
  }

  &__details {
    line-height: 20px;
    font-size: 16px;
    color: #505B75;
    &__devider {
      width: 1px;
      height: 100%;
      margin: 0 15px 0 13px;
      border-right: 2px solid #EDEDED;
    }
  }
  &__total {
    padding-right: 20px;
    font-size: 25px;
    font-weight: bold;
    &.completed {
      color: #c64242;
    }
    &.opened {
      color: green;
    }
  }
  .commands {
    margin-right: 20px;
  }
}
</style>
